import { request } from '../../helpers/api/request';
import { IModifyDataForUpdateProduct } from '../../pages/Goods/EditGood/PriceOffers/interface';

const getUrl = (id: number): string => `admin/products/${id}/goods`;

export const updateProductGoods = async (
    updatedData: { size: IModifyDataForUpdateProduct[] },
    id: number,
) => {
    const { data } = await request({
        method: 'PATCH',
        url: getUrl(id),
        data: updatedData,
    });

    return data;
};
